export default "__VITE_ASSET___AfORaLa__"